import css from '@styled-system/css'
import styled from 'styled-components'

const Svg = styled.svg(
  css({
    position: 'absolute',
    top: '0',
    insetInlineStart: '0',
    width: '100%',
    height: '100%',
  }),
)

export default Svg
